export default "<tc-generic-list #estimationsList id=\"dashboard-estimations-list\"></tc-generic-list>";